import { render, staticRenderFns } from "./TemplateViewContract.vue?vue&type=template&id=2cbc6ff4&scoped=true"
import script from "./TemplateViewContract.vue?vue&type=script&lang=js"
export * from "./TemplateViewContract.vue?vue&type=script&lang=js"
import style0 from "./TemplateViewContract.vue?vue&type=style&index=0&id=2cbc6ff4&prod&lang=scss"
import style1 from "./TemplateViewContract.vue?vue&type=style&index=1&id=2cbc6ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc6ff4",
  null
  
)

export default component.exports